import { FeedbackMetadataValues } from '@modules/feedback/components/FeedbackCard/FeedbackMetadataKeyValues';
import { Box, Stack, Tooltip, Typography } from '@mui/material';
import { MetadataValue } from 'generated/graphql';

interface FeedbackMetadataKeyValuesProps {
  displayName: string;
  values: string[];
  metadataValue?: MetadataValue;
  metadataFieldKey?: string;
  shouldAddOpenInSearchLink?: boolean;
  feedbackID: string;
}

export const FeedbackMetadataKeyValues = ({
  displayName,
  values,
  metadataValue,
  metadataFieldKey,
  shouldAddOpenInSearchLink,
  feedbackID,
}: FeedbackMetadataKeyValuesProps) => {
  return (
    <Stack spacing={0.5}>
      <Tooltip arrow title={displayName} placement="top-start">
        <Typography variant="caption" color="text.secondary" noWrap>
          {displayName}
        </Typography>
      </Tooltip>
      <Box>
        <FeedbackMetadataValues
          displayName={displayName}
          values={values}
          metadataValue={metadataValue}
          metadataFieldKey={metadataFieldKey}
          shouldAddOpenInSearchLink={shouldAddOpenInSearchLink}
          feedbackID={feedbackID}
        />
      </Box>
    </Stack>
  );
};
